module.exports = __webpack_public_path__ + "a64f0d95daaad0c87a7f773dc39d68d7.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/koket_desk_gray.gif
 ** module id = 453
 ** module chunks = 0
 **/